import { render } from "./SoftwareProjects.vue?vue&type=template&id=79fe60f1&scoped=true"
import script from "./SoftwareProjects.vue?vue&type=script&lang=js"
export * from "./SoftwareProjects.vue?vue&type=script&lang=js"

import "./SoftwareProjects.vue?vue&type=style&index=0&id=79fe60f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fe60f1"]])

export default __exports__